import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISearchService = ( createDecorator('searchService'));
export { ISearchService };
